'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultCharsRules = exports.defaultCharsRules = {
  '9': '[0-9]',
  'a': '[A-Za-z]',
  '*': '[A-Za-z0-9]'
};

var defaultMaskChar = exports.defaultMaskChar = '_';


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-input-mask/lib/constants/index.js
 ** module id = 500
 ** module chunks = 0
 **/